import { useEffect, useState } from 'react';
import CustomDataGrid from '../../../Shared/Table/CustomDataGrid';
import { GridEventListener, GridRowParams, GridSortModel} from '@mui/x-data-grid';
import { IEvent } from '../../../../store/api/devices/types';
import EventDrawer from '../../../Drawers/EventDrawer';
import { getSortBy } from '../../../../utils/helpers';
import { useRedundancyDisplay } from './hooks';
import ActivityLogFilter from './ActivityLogFilter';

const ActivityLog = () => {
  const {data, isLoading, eventsColumns, setSortOrderToEvent } = useRedundancyDisplay();
  const [filteredRows, setFilteredRows] = useState<IEvent[]>([]);
  const [rowClicked, setRowClicked] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<IEvent>();
  const rowsData = data?.data || [];
  const noOfRows = data?.totalItems || 0;

  const handleCloseButtonClicked = (value: boolean) => {
    setRowClicked(value);
  };

  useEffect(() => {
    const filtered = rowsData?.filter(row => row?.managedObject === 
        "Redundancy Manager");
    setFilteredRows(filtered);
  }, [rowsData]);

  const handleRowClicked: GridEventListener<"rowClick"> = (params: GridRowParams<IEvent>) => {
      setRowClicked(true);
      setSelectedRowData(params.row);
    };

  return (
    <div className="flex flex-col justify-center items-start w-full">
      <hr className="w-full border-border" />
      {rowClicked && <EventDrawer data={selectedRowData} setRowClicked={setRowClicked} closedButtonClicked={handleCloseButtonClicked} isAlarmContext={false} />}

      <div className="flex items-center justify-between w-full px-3 py-1">
        <div>
          <h6 className="text-base font-semibold text-foreground">Activity Events</h6>
        </div>
      </div>

      <div className="ml-1 mb-5">
        <ActivityLogFilter />
      </div>

      <div className="px-3 py-1">
        <span className="text-sm text-muted-foreground">{`Showing ${noOfRows} results`}</span>
      </div>

      <div className="w-full p-3">
        <CustomDataGrid
          tableId="eventDisplay"
          rows={rowsData}
          columns={eventsColumns}
          checkboxSelection={false}
          rowCount={noOfRows}
          loading={isLoading}
          disableColumnMenu={true}
          getRowId={(row: IEvent) => row.objectKey}
          onSortModelChange={(params: GridSortModel) => setSortOrderToEvent(getSortBy(params))}
          onRowClick={handleRowClicked}
          sx={{ width: '100%' }}
        />
      </div>
    </div>
  );
}

export default ActivityLog;